import React, { Component } from 'react';
import "./DealersInfo.scss";
import {StateHandlerService} from '../../../services/stateHandlerService';
import axios from "axios";
import { Link } from "react-router-dom";

export default class DealersInfo extends Component {
 
 
    

    stateService = new StateHandlerService();
    constructor() {
      super();
     
      this.service = axios.create({
        baseURL: process.env.REACT_APP_SERVICE_ADESIS_URL
      });  
     
     
      this.state = {

        dealers:[],
        controls:{
          start:0,
          end:5
        },
       
      }
        this.stateService.dealers$.subscribe(
          data => {
            this.setState({dealers:data})
          
          });
          this.stateService.controls$.subscribe(
            data => {
              this.setState({controls:data})
            
            });
      }
    
      
      moveLeft(){
      let start = Math.max(this.state.controls.start-5,0);
       let end =Math.max(this.state.controls.end-5,0,start); 
         this.stateService.publishControls({
          start,
          end
        });
         this.stateService.publishDealers(this.state.dealers);
    
    
      }
      moveRight(){
      
      
         this.stateService.publishControls({
          start:Math.min(this.state.controls.start+5,this.state.dealers.length),
          end:Math.min(this.state.controls.end+5,this.state.dealers.length)
        });
         this.stateService.publishDealers(this.state.dealers);
    
    
      }

      async confirmDealer(dealer){
        console.log('dealer: ', dealer)

        this.props.setRedirectToInit();

        let workshop = {
          DealershipId: dealer.localDealerID,
          DealershipName: dealer.name,
          DealershipAddress: dealer.address.address1,
          DealershipCity: dealer.address.city,
          DealershipZipCode: dealer.address.zip
        }

        this.props.getWorkshopSelect(workshop)

        // this.service
        //   .get(
        //     `/Concesionario/GetConcesionariosByActivity?bMecanica=1&bChapa=0&bRepuestos=0`
        //   )
        //   .then(response => {
        //     console.log(dealer)
        //     // console.log("dealers", response.data.Data);
        //     // console.log('dealer: ', dealer)
        //     // console.log('filtered: ', response.data.Data.filter(element => element.DealershipId == '3101-1'))

        //     let dealerFiltered = response.data.Data.filter(element =>
        //       // parseInt(element.DealershipId.split('-')[0])+'-' + parseInt(element.DealershipId.split('-')[1]) == parseInt(dealer.localDealerID.split('-')[0])+'-'+parseInt(dealer.localDealerID.split('-')[1])
        //       parseInt(element.DealershipId.split('-')[1]) == parseInt(dealer.localDealerID.split('-')[0]) && element.DealershipZipCode == dealer.address.zip
        //     );
        //     // console.log('filtered: ', dealerFiltered)
            
        //     // Lexus Concesionarios (Precios por zona en vez de por Taller)
        //     // TODO: !Revisar si es así, sino actualizar las tablas con los concesionarios y sus precios
        //     let workshop = dealerFiltered[0]
        //     workshop.DealershipAddress = dealer.address.address1
        //     workshop.DealershipCity = dealer.address.city
        //     workshop.DealershipName = dealer.name
        //     workshop.DealershipZipCode = dealer.address.zip

        //     console.log(workshop)

        //     // this.props.getWorkshopSelect(dealerFiltered[0])
        //     this.props.getWorkshopSelect(workshop)
        //   })
        //   .catch(e => console.log(e));
    
    }
 

    render() {
    return (
<div>
{this.state.dealers.length>0?(

<div >
    <div className="container-dealers-info">
    {this.state.dealers.length>5?(

<div  className="arrows-buttons">
<button disabled={this.state.controls.start==0} className="button-arrow-left"  onClick={()=>{this.moveLeft()}}></button>
<p style={{ marginBottom: 0 }}>{parseInt(this.state.controls.start/5)+1 } de {this.state.dealers.length%5 ? Math.trunc(this.state.dealers.length/5)+1  : this.state.dealers.length/5}</p>
<button disabled={this.state.controls.end==this.state.dealers.length} className="button-arrow-right"  onClick={()=>{this.moveRight()}}></button> 

</div>

    ):null} 

 {      this.state.dealers.slice(this.state.controls.start,this.state.controls.end).map( (dealer,index) => {

return (<div key={index}>
<div className="dealer-card">
<Link 
// to="/carRegistration"
to="/modelSelector"
onClick={()=>{this.confirmDealer(dealer)}} >
    <div className="row-number">
      <div className="number-order"> {index+1+this.state.controls.start}</div>
    </div>

  
        <div className="row-info">
            {/* <p> <span className="info_value" style={{ fontSize: 16 }}><strong>{dealer.name.split('-')[0]}</strong></span></p> */}
            <p> <span className="info_value" style={{ fontSize: 14.5, fontWeight: 600 }}>{dealer.name.split('-')[0]}</span></p>
            <p> <span className="info_value" style={{ fontSize: 12.5 }}>{dealer.address.address1}</span></p>
            <p> <span className="info_value" style={{ fontSize: 12.5 }}>{dealer.distance.toFixed(1)} km</span></p>
            <p> <span className="info_value" style={{ fontSize: 12.5 }}>{dealer.address.zip || ''}&nbsp;({dealer.address.city || ''})</span></p>
        </div>
    
     <div  className="row-arrow">    
      
     </div>
</Link>
</div>

</div>)

} )

} 
    </div>
    
    
    </div>

):null}








</div>
    );
  }
}
